
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const HomeHeader = () => {
  return (
    <header className="fixed w-full top-0 z-10 bg-gray-800 text-white shadow-md">
      <div className="container mx-auto px-4 py-3 flex justify-between items-center">
        <div className="flex-1"></div>
        
        <div className="flex justify-center">
          <Link to="/" className="flex items-center group">
            <img 
              src="/lovable-uploads/39686db0-4967-4556-a4f9-65cbf5776672.png" 
              alt="SunJob Technology" 
              className="h-16 w-auto" 
            />
          </Link>
        </div>
        
        <div className="flex-1 flex justify-end">
          <Link to="/login">
            <Button 
              variant="ghost"
              className="bg-gray-700 hover:bg-gray-600 text-white rounded-full px-4 py-2 flex items-center gap-2 transition-all duration-300"
            >
              Entrar
            </Button>
          </Link>
        </div>
      </div>
    </header>
  );
};

export default HomeHeader;
